/**
 * @Date: 2020-05-26 10:22
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import http from '../http'

export const productQueryPage = data => {
  return http.request({
    url: '/basic/productQueryPage',
    data,
    method: 'post'
  })
}

export const productQueryList = data => {
  return http.request({
    url: '/basic/productQueryList',
    data,
    method: 'get'
  })
}

// 启用禁用
export const productEnableDisable = data => {
  return http.request({
    url: '/basic/productEnableDisable',
    data,
    method: 'post'
  })
}
